import { FormikErrors } from "formik";

function isNullish(value: any): boolean {
  return value === null || value === undefined;
}

export class FormikErrorAccumulator<T> {
  errors: FormikErrors<T>;

  constructor(initial?: FormikErrors<T>) {
    this.errors = initial ?? {};
  }

  add(error: FormikErrors<T>): void {
    for (const key in error) {
      // skip if there is error value is undefined
      if (isNullish(error[key])) {
        continue;
      }

      if (key in this.errors && !isNullish(this.errors[key])) {
        this.errors[key] = `${this.errors[key]} ${error[key]}` as any;
      } else {
        this.errors[key] = error[key];
      }
    }
  }
}
